<template>
  <b-modal
    :visible="showModal"
    title="Cancelar Transferência de Bike"
    header-bg-variant="warning"
    header-text-variant="dark"
    centered
    no-close-on-backdrop
    @hide="$emit('hide')"
  >
    <div v-if="!resultado">
      <p class="mb-2">
        Você está prestes a cancelar a transferência de bike pendente do cliente:
      </p>
      <ul class="mb-3">
        <li><b>E-mail:</b> {{ email }}</li>
      </ul>
      <div class="alert alert-warning mb-0">
        <strong>Atenção:</strong> essa ação irá cancelar a transferência pendente associada a este cliente.
        Confirme antes de prosseguir.
      </div>
    </div>

    <div v-if="resultado && resultado.sucesso">
      <div class="alert alert-success mb-0">
        <strong>{{ resultado.mensagem }}</strong>
      </div>
    </div>

    <div v-if="resultado && !resultado.sucesso">
      <div class="alert alert-danger mb-0">
        <span style="white-space: pre-line;">{{ resultado.erro }}</span>
      </div>
    </div>

    <template #modal-footer>
      <div v-if="!resultado" class="w-100 d-flex justify-content-end">
        <b-button variant="secondary" class="mr-2" @click="$emit('hide')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="warning" @click="confirmar" :disabled="loading">
          <span v-if="!loading">Sim, cancelar transferência</span>
          <span v-else>Aguarde...</span>
        </b-button>
      </div>
      <div v-else class="w-100 d-flex justify-content-end">
        <b-button variant="secondary" @click="$emit('hide')">Fechar</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";
import config from "../../config";
import auth from "../../auth";
import captureError from "../../helpers/captureError";

export default {
  props: {
    showModal: { type: Boolean, default: false },
    email: { type: String, default: null },
  },
  data() {
    return {
      loading: false,
      resultado: null,
    };
  },
  watch: {
    showModal(val) {
      if (val) {
        this.resultado = null;
        this.loading = false;
      }
    },
  },
  methods: {
    async confirmar() {
      if (!this.email) return;

      this.loading = true;

      try {
        const userInfo = auth.getUserInfo();
        const response = await axios.post(
          `${config.API_URLV2}/TransferenciaBike/cancelar`,
          { Email: this.email },
          {
            headers: {
              Authorization: `Bearer ${userInfo ? userInfo.token : ""}`,
              "Content-Type": "application/json",
            },
          }
        );

        this.resultado = {
          sucesso: true,
          mensagem: (response.data && response.data.message) || "Transferência cancelada com sucesso.",
        };
      } catch (error) {
        const apiData = error.response && error.response.data;
        const erroApi = apiData && apiData.error;
        if (erroApi) {
          this.resultado = { sucesso: false, erro: erroApi };
        } else {
          captureError(error);
          this.resultado = { sucesso: false, erro: "Erro ao conectar com o servidor. Tente novamente mais tarde." };
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
